import { isValid } from "date-fns";

export const dateToYYYYMMDD = (date:Date) => {
    if(date){
        let dt = new Date(date);
        if(isValid(dt)){
            let d = dt.getDate().toString();
            if(d.length < 2){d = "0"+d}

            let m = (dt.getMonth() + 1).toString();
            if(m.length < 2){m = "0"+m}

            let y = dt.getFullYear().toString();

            return y+m+d;
        }
        else {
            return ""
        }
    }
    else {
        return ""
    }
}

export const YYYYMMDDtoDate = (dateString:string) => {
    const year = parseFloat(dateString.substring(0, 4));
    const month = parseFloat(dateString.substring(4, 6)) - 1;
    const day = parseFloat(dateString.substring(6, 8));
    return new Date(year, month, day);
}

export const removeNonAlphaNumeric = (str:string) => {
    return str.replace(/[^a-zA-Z0-9]/g, "");
}